import React, { useState } from 'react';
import axios from 'axios';

const ProductSearchScan = ({ addProductToInvoice }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProducts = async () => {
        if (!searchQuery.trim()) {
            setError("Please enter a product name or barcode.");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await axios.get(`https://merch.tjdstore.in/api/Backend/get_product.php?query=${searchQuery}`);
            console.log('Response data:', response.data);

            if (Array.isArray(response.data)) {
                setProducts(response.data);
            } else {
                setProducts([]);
                console.error('Invalid data:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            setError('Failed to fetch products. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
                        <div className="col-md-4">
                        <h5>Search or Scan Products</h5>
            <input className="form-control"
                type="text"
                placeholder="Enter product name or scan barcode"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="btn btn-primary" onClick={fetchProducts} disabled={loading}>
                {loading ? 'Loading...' : 'Search'}
            </button>
            </div>
            {error && <div style={{ color: 'red' }}>{error}</div>}

            {products.length > 0 ? (
                <div className="col-md-12">
                <table className="table prev">
                    {products.map((product) => (
                        <tr key={product.Product_ID}>
                            <th>{product.Product_ID} </th>
                            <th>{product.Product_Name} </th><th><img
                                    src={product.Product_Img}
                                    alt={product.Product_Name}
                                    style={{ width: '100px', height: 'auto' }}
                                /></th><th>    ₹{product.Product_Price}  </th><th>     {product.Product_Size}</th>
                            <th><button className="btn btn-success" type="button" onClick={() => addProductToInvoice(product)}>Add to Invoice</button></th>

                        </tr>
                    ))}
                </table>
                </div>
            ) : (
                <p>No products found</p>
            )}
        </div>
    );
};

export default ProductSearchScan;




